import { type TableSelectedCell, useTableRows } from '@/components/custom/erp/input-table-v2';

export type SelectedCellInfo = TableSelectedCell;

export function useDetailRows<
  T extends {
    uuid: string;
    line?: number;
  }
>(
  initialRows: T[] = [],
  onChange?: (rows: T[]) => void,
  onFieldValueChange?: (row: T, field: string, value: BanHangValue) => Partial<T>
) {
  const {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    selectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs
  } = useTableRows<T>({
    initialRows,
    defaultRows: 1,
    onChange,
    onFieldValueChange,
    defaultField: 'ma_vt'
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    selectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs
  };
}
